var React = require('react');

function CircleSmallPartBack (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M93.603,0C43.159,2.576,2.701,42.958,0,93.369h93.603V0z"})));
}

CircleSmallPartBack.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"93.603px","height":"93.369px","viewBox":"0 0 93.603 93.369","enableBackground":"new 0 0 93.603 93.369","xmlSpace":"preserve"};

module.exports = CircleSmallPartBack;

CircleSmallPartBack.default = CircleSmallPartBack;
